/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { welcomeScreensUpdate } from '../../axios/welcomeScreensUpdate'
import type {
	WelcomeScreensUpdateError,
	WelcomeScreensUpdatePathParams,
	WelcomeScreensUpdateRequest,
	WelcomeScreensUpdateResponse,
} from '../../types/WelcomeScreensUpdate'

export const welcomeScreensUpdateMutationKey = () => [{ url: '/welcome-screens/:welcomeScreen' }] as const

export type WelcomeScreensUpdateMutationKey = ReturnType<typeof welcomeScreensUpdateMutationKey>

export type WelcomeScreensUpdateVariables = {
	welcomeScreen: WelcomeScreensUpdatePathParams['welcomeScreen']
	data: WelcomeScreensUpdateRequest
}

/** @see backend/nexus/modules/Form/Http/Controllers/WelcomeScreenController.php WelcomeScreenController::update */
export function useWelcomeScreensUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		WelcomeScreensUpdateResponse,
		AxiosError<WelcomeScreensUpdateError>,
		WelcomeScreensUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: welcomeScreensUpdateMutationKey(),
		mutationFn: ({ welcomeScreen, data }: WelcomeScreensUpdateVariables) =>
			welcomeScreensUpdate(welcomeScreen, data, config).then(res => res.data),
		...options,
	})
}
